<template>
  <div class="app-checkout-success-with-ident-wrapper">
    <slot v-if="this.identType === 'video' && !this.mnpActive" name="videoIdentNoMnp"></slot>
    <slot v-if="this.identType === 'video' && this.mnpActive" name="videoIdentMnp"></slot>
    <slot v-if="this.identType === 'store' && !this.mnpActive" name="postIdentNoMnp"></slot>
    <slot v-if="this.identType === 'store' && this.mnpActive" name="postIdentMnp"></slot>
    <div v-if="processId !== 'dummy-process-id'">
      <script type="application/javascript">
        var di = {t:'{{this.contractId}}',v:'{{fridaData.snippedId}}',l:'checkout'};
      </script>
      <script type="application/javascript" :src="'//jsctool.com/' + fridaData.snippedId + '/di.js'"></script>
      <noscript><link rel="stylesheet" type="text/css" :href="'//www.jsctool.com/di.css?t=' + this.contractId + '&v=' + fridaData.snippedId + '&l=checkout'"></noscript>
      <link rel="stylesheet" type="text/css" media="sub" :href="'//' + fridaData.fridaUrl + '/di.css?t=' + this.contractId + '&sd=1&v=' + fridaData.snippedId + '&l=checkout'">
    </div>
  </div>
</template>

<script>

import { checkoutTracking } from '@/helper/checkoutTracking'
import { mapActions } from 'vuex'

export default {
  name: 'SuccessWithIdent',
  components: {},
  data () {
    return {
      deferredResponse: null,
      contractId: '',
      processId: '',
      identType: '',
      mnpActive: null,
      fridaData: {
        snippedId: process.env.NODE_ENV !== 'production' ? 'tEhcH8' : 'GvHD2a',
        fridaUrl: process.env.NODE_ENV !== 'production' ? 'd.' + location.hostname + (location.port ? ':' + location.port : '') : 'd.simonmobile.de'
      }
    }
  },
  props: {
    identurlErrorPage: {
      type: String,
      default: '#'
    },
    process: {
      type: String,
      default: 'ordering'
    },
    stepNo: {
      type: Number,
      default: 6
    }
  },
  async mounted () {
    if (this.$store.getters['checkoutv2/' + this.process + '/confirmResult'].contractId === '') {
      window.location = '/'
    } else {
      await this.fillData()
      document.querySelector('#startIdent').addEventListener('click', this.selectIdentUrl, false)
      this.trackSuccess()
      this.resetStore()
    }
  },
  mixins: [],
  methods: {
    ...mapActions('checkout', [
      'resetCompleteCheckoutStore'
    ]),
    selectIdentUrl () {
      if (this.deferredResponse?.url === null || typeof this.deferredResponse?.url === 'undefined') {
        window.open(this.identurlErrorPage, '_self')
      } else {
        window.open(this.deferredResponse?.url, '_blank').focus()
      }
    },
    fillData () {
      this.deferredResponse = this.$store.getters['checkoutv2/' + this.process + '/confirmResult']?.deferredIdentificationResponse
      this.contractId = this.$store.getters['checkoutv2/' + this.process + '/confirmResult']?.contractId
      this.processId = this.$store.getters['checkoutv2/' + this.process + '/processId']
      this.identType = this.$store.getters['checkoutv2/' + this.process + '/_identData/identData']?.identType
      this.mnpActive = this.$store.getters['checkoutv2/' + this.process + '/_mnpData/active']
    },
    trackSuccess () {
      checkoutTracking(this.process, this.$store, 'success', this.stepNo)
    },
    resetStore () {
      this.$store.dispatch('checkoutv2/' + this.process + '/resetState')
      this.resetCompleteCheckoutStore()
    }
  },
  computed: {}
}
</script>
